export default __webpack_public_path__ + "static/hero-image-05e1d05a1b80b8560b231520000897b5.svg";